var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMenuRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.706875 21.9202C1.0974 22.3108 1.73056 22.3108 2.12109 21.9202L12.0206 12.0207C12.4111 11.6302 12.4111 10.9971 12.0206 10.6065L2.12109 0.707037C1.73056 0.316513 1.0974 0.316513 0.706874 0.707037C0.31635 1.09756 0.31635 1.73073 0.706874 2.12125L9.89926 11.3136L0.706875 20.506C0.31635 20.8966 0.31635 21.5297 0.706875 21.9202Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuRight);
export default __webpack_public_path__ + "static/media/arrowMenuRight.d494082420cda9d76176bd0f59e4714a.svg";
export { ForwardRef as ReactComponent };